<small class="flex">
  <span class="rounded-3xl bg-gray-4 px-1.5 text-gray-12">
    <ng-content></ng-content>
  </span>
  <button mat-icon-button (click)="copy()" type="button">
    <mat-icon class="material-icon"> {{ copied() ? 'check' : 'file_copy' }}</mat-icon>
  </button>
</small>
